// extracted by mini-css-extract-plugin
export default {"container":"tQ-z","modal":"uQ-z","dimensions":"vQ-z","brandName":"wQ-z","productName":"xQ-z","recipientEmail":"yQ-z","recommendedFit":"zQ-z","hiddenField":"AQ-z"};